import classNames from 'classnames';
import * as React from 'react';
import navStyles from '../Shared/Styles/NavButton.module.css';
import ExecutionContext from '~/Features/ExecutionContext';
import { Button } from '~/Partials/Button/Button';
import type { NavButtonProps } from '~/Partials/Nav/Components/NavButtons/NavButtons';
import { SvgIcon } from '~/Partials/SvgIcon/SvgIcon';
import styles from './BasketButton.module.css';

interface BasketButtonTranslations {
    basket: string;
    youHaveNoChosenStudies: string;
    seeAllStudies: string;
}

interface BasketButtonProps extends NavButtonProps {
    basketLinkUrl: string;
    translations: BasketButtonTranslations;
}

export const BasketButton: React.FC<React.PropsWithChildren<BasketButtonProps>> = ({
    basketLinkUrl,
    translations,
    variant,
}) => {
    const handleButtonClick = () => {
        if (!ExecutionContext.IsServerSide()) {
            window.location.href = basketLinkUrl;
        }
    };

    return (
        <div>
            <Button
                onClick={handleButtonClick}
                className={classNames(navStyles.ButtonIcon, variant && navStyles[`Variant--${variant}`])}
            >
                <span className="visuallyHidden">{translations.basket}</span>
                <SvgIcon iconName="basket" className={styles.Dot} />
            </Button>
        </div>
    );
};
